import {
  accountSearchColumns,
  hanThanhToanSearchColumns,
  khuVucSearchColumns,
  nhanVienSearchColumns,
  nhomNhaCungCapSearchColumns,
  phuongThucThanhToanSearchColumns,
  QUERY_KEYS
} from '@/constants';
import { AccountModel, Group, GroupType, HanThanhToan, KhuVuc, NhanVien, PhuongThucThanhToan } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { FormActions, FormState } from '../../../hooks';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
  formState: {
    state: FormState;
    actions: FormActions;
  };
}

export const GeneralTab = ({ formMode, formState: { state, actions } }: Props) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='grid grid-cols-1 gap-x-8 space-y-2 p-4 lg:grid-cols-1 lg:space-y-0'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhân viên bán hàng</Label>
        <SearchField<NhanVien>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.NHAN_VIEN}`}
          searchColumns={nhanVienSearchColumns}
          dialogTitle='Danh mục nhân viên'
          columnDisplay='ma_nhan_vien'
          displayRelatedField='ho_ten_nhan_vien'
          value={state.nhanVien?.ma_nhan_vien || ''}
          relatedFieldValue={state.nhanVien?.ho_ten_nhan_vien || ''}
          onRowSelection={actions.setNhanVien}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Tài khoản ngầm định</Label>
        <SearchField<AccountModel>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          columnDisplay='code'
          displayRelatedField='name'
          value={state.taiKhoanNgamDinh?.code || ''}
          relatedFieldValue={state.taiKhoanNgamDinh?.name || ''}
          onRowSelection={actions.setTaiKhoanNgamDinh}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Mã th.toán công nợ</Label>
        <SearchField<HanThanhToan>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.HAN_THANH_TOAN}`}
          searchColumns={hanThanhToanSearchColumns}
          dialogTitle='Danh mục thanh toán'
          columnDisplay='ma_tt'
          displayRelatedField='ten_tt'
          value={state.thanhToan?.ma_tt || ''}
          relatedFieldValue={state.thanhToan?.ten_tt || ''}
          onRowSelection={actions.setThanhToan}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Ph/th th.toán (HĐĐT)</Label>
        <SearchField<PhuongThucThanhToan>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}`}
          searchColumns={phuongThucThanhToanSearchColumns}
          dialogTitle='Danh mục phương thức thanh toán'
          columnDisplay='ma_pttt'
          displayRelatedField='ten_pttt'
          value={state.phuongThucThanhToan?.ma_pttt || ''}
          relatedFieldValue={state.phuongThucThanhToan?.ten_pttt || ''}
          onRowSelection={actions.setPhuongThucThanhToan}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Giới hạn tín dụng</Label>
        <div className='w-[200px]'>
          <FormField name='credit_limit' type='number' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhóm 1</Label>
        <SearchField<Group>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER1}`}
          searchColumns={nhomNhaCungCapSearchColumns}
          dialogTitle='Danh mục nhóm nhà cung cấp 1'
          columnDisplay='ma_nhom'
          displayRelatedField='ten_phan_nhom'
          value={state.nhom1?.ma_nhom || ''}
          relatedFieldValue={state.nhom1?.ten_phan_nhom || ''}
          onRowSelection={actions.setNhom1}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhóm 2</Label>
        <SearchField<Group>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER2}`}
          searchColumns={nhomNhaCungCapSearchColumns}
          dialogTitle='Danh mục nhóm nhà cung cấp 2'
          columnDisplay='ma_nhom'
          displayRelatedField='ten_phan_nhom'
          value={state.nhom2?.ma_nhom || ''}
          relatedFieldValue={state.nhom2?.ten_phan_nhom || ''}
          onRowSelection={actions.setNhom2}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Nhóm 3</Label>
        <SearchField<Group>
          type='text'
          searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=${GroupType.CUSTOMER3}`}
          searchColumns={nhomNhaCungCapSearchColumns}
          dialogTitle='Danh mục nhóm nhà cung cấp 3'
          columnDisplay='ma_nhom'
          displayRelatedField='ten_phan_nhom'
          value={state.nhom3?.ma_nhom || ''}
          relatedFieldValue={state.nhom3?.ten_phan_nhom || ''}
          onRowSelection={actions.setNhom3}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Khu vực</Label>
        <SearchField<KhuVuc>
          type='text'
          name='region'
          searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
          searchColumns={khuVucSearchColumns}
          dialogTitle='Danh mục khu vực'
          columnDisplay='rg_code'
          displayRelatedField='rgname'
          value={state.khuVuc?.rg_code || ''}
          relatedFieldValue={state.khuVuc?.rgname || ''}
          onRowSelection={actions.setKhuVuc}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Điện thoại</Label>
        <div className='w-[250px]'>
          <FormField name='phone' type='text' disabled={isViewMode} />
        </div>
        <div className='w-full'>
          <FormField
            className='ml-1'
            label='Fax'
            name='fax'
            type='text'
            labelClassName='min-w-[100px]'
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Thư (Email)</Label>
        <div className='w-[250px]'>
          <FormField name='email' type='text' disabled={isViewMode} />
        </div>
        <div className='w-full'>
          <FormField
            className='ml-1'
            label='Trang chủ(Website)'
            name='website'
            type='text'
            labelClassName='min-w-[100px]'
            disabled={isViewMode}
          />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Ghi chú</Label>
        <div className='w-full'>
          <FormField name='notes' type='text' disabled={isViewMode} />
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left'>Trạng thái</Label>
        <div className='w-[250px]'>
          <FormField
            name='status'
            type='select'
            disabled={isViewMode}
            options={[
              { value: '1', label: '1. Còn sử dụng' },
              { value: '0', label: '0. Không sử dụng' }
            ]}
          />
        </div>
      </div>
    </div>
  );
};
